import React, { createContext, useContext, useState, useCallback } from "react";
import axios from "axios";
import { BASE_URL } from "../config/apiconfig";

const OrderCancelContext = createContext();

export const useOrderCancel = () => useContext(OrderCancelContext);

export const OrderCancelProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Submit order cancellation request
  const submitCancelRequest = useCallback(async (cancelData) => {
    setLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem("token");
      const user = localStorage.getItem("user");

      if (!token || !user) {
        throw new Error("Please login to cancel an order.");
      }

      const userData = JSON.parse(user);
      const userId = userData?.id;

      if (!userId) {
        throw new Error("User ID not found. Please login again.");
      }

      const requestData = {
        order_id: cancelData.orderId,
        user_id: userId,
        content: cancelData.reason
      };


      const response = await axios.post(`${BASE_URL}/order/cancel`, requestData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });


      if (response.data.status === true) {
        return {
          success: true,
          message: response.data.message || 'Order cancellation request submitted successfully',
          data: response.data
        };
      } else {
        throw new Error(response.data.message || 'Failed to submit cancellation request');
      }
    } catch (err) {

      let errorMessage = 'Failed to submit cancellation request. Please try again.';

      if (err.response?.status === 401) {
        errorMessage = 'Session expired. Please login again.';
      } else if (err.response?.status === 422) {
        errorMessage = 'Invalid data provided. Please check your inputs.';
      } else if (err.response?.status >= 500) {
        errorMessage = 'Server error. Please try again later.';
      } else if (err.response?.data?.message) {
        errorMessage = err.response.data.message;
      } else if (err.message) {
        errorMessage = err.message;
      }

      setError(errorMessage);
      return {
        success: false,
        error: errorMessage
      };
    } finally {
      setLoading(false);
    }
  }, []);

  // Clear error
  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return (
    <OrderCancelContext.Provider value={{
      loading,
      error,
      submitCancelRequest,
      clearError
    }}>
      {children}
    </OrderCancelContext.Provider>
  );
};
